export namespace QsChecksConstants {
    export const BOUNDED_CONTEXT_NAME = 'QsChecks';
    export const QS_CHECKS_LIZENZ_MODUL = 'qschecks';
    
}

